import { useState, useEffect } from 'react';
import { Button, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from 'reactstrap';
import { toast } from 'react-toastify';
import { apiFetch } from '../../services/apiFetch';

const API_URL = import.meta.env.VITE_API_URL;

export default function SendQuoteModal({ isOpen, onClose, quote }) {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [expiryDate, setExpiryDate] = useState('');
    const [sending, setSending] = useState(false);

    // Pre-fill email and default expiry when modal opens.
    useEffect(() => {
        if (isOpen) {
            if (quote?.customerEmail) setEmail(quote.customerEmail);
            const d = new Date();
            d.setDate(d.getDate() + 30);
            setExpiryDate(`${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`);
        }
    }, [isOpen, quote?.customerEmail]);

    const handleSend = async () => {
        if (!email.trim()) return;
        setSending(true);
        try {
            await apiFetch(`${API_URL}/api/Quote/SendQuoteEmail/${quote.id}`, {
                method: 'POST',
                body: JSON.stringify({ recipientEmail: email.trim(), message: message.trim() || null, expiryDate: expiryDate || null }),
            });
            toast.success('Quote sent successfully!');
            onClose();
        } catch (err) {
            toast.error(err?.message ?? 'Failed to send quote.');
        } finally {
            setSending(false);
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={onClose} centered>
            <ModalHeader toggle={onClose}>Send Quote</ModalHeader>
            <ModalBody>
                <p className="text-muted small mb-3">
                    The quote PDF will be emailed to the recipient with your company branding.
                    The quote status will be set to "Sent" automatically.
                </p>
                <Label className="small fw-semibold">Recipient Email *</Label>
                <Input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="customer@example.com"
                    className="mb-3"
                />
                <Label className="small fw-semibold">Message (optional)</Label>
                <Input
                    type="textarea"
                    rows={3}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="Add a personal message..."
                    className="mb-3"
                />
                <Label className="small fw-semibold">Expires On</Label>
                <Input
                    type="date"
                    value={expiryDate}
                    onChange={(e) => setExpiryDate(e.target.value)}
                />
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" outline onClick={onClose} disabled={sending}>Cancel</Button>
                <Button color="primary" onClick={handleSend} disabled={sending || !email.trim()}>
                    {sending ? <><Spinner size="sm" className="me-1" /> Sending...</> : 'Send Quote'}
                </Button>
            </ModalFooter>
        </Modal>
    );
}
